import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { ItemCardStyled } from '../../ui/ItemCard/styled';

export const HeaderWrapper = styled.div`
  @media (min-width: ${Breakpoints.tablet}px) {
    display: none;
  }
`;

export const AgencyLayout = styled.div`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
`;

export const AgencyContent = styled.div`
  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 0 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 20px 20px 0 20px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    width: 1280px;
    max-width: calc(100% - 40px);
    margin: auto;
  }
`;

export const AgencyItemsWrapper = styled.div`
  padding: 10px 0 0;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 24px 24px 0 0;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 10px 0;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 30px 0;
    border-radius: 24px;
    margin-bottom: 50px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    ${ItemCardStyled} {
      flex: 1 1 calc(100% / 5);
      max-width: calc((100% / 5) - 10px);
    }
  }
`;

export const BottomPhoneWrapper = styled.div`
  padding: 0 15px 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px 20px;
  }
`;
